import React from 'react';
import DashboardLayout from '../../../components/DashboardLayout';

const PackagingOperationsDashboard: React.FC = () => {

    return (
        <DashboardLayout>
            <div className="p-4 md:p-6 lg:p-8 space-y-6">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white p-5 rounded-lg border border-slate-300 shadow-sm">
                    <div>
                        <h1 className="text-xl md:text-2xl font-extrabold text-slate-900 leading-tight m-0">Packaging Operations Dashboard</h1>
                        <p className="mt-1 text-sm text-slate-500 font-medium">Manage and review packaging parameter checks.</p>
                    </div>
                    <div>
                        {/* <button 
                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 shadow-sm"
                            onClick={() => navigate('/rajpura-product-production-operations')}
                        >
                            + Start New Quality Tour
                        </button> */}
                    </div>
                </div>

                <div className="bg-white rounded-lg border border-slate-300 shadow-sm p-8 text-center text-slate-500">
                    <p>No active or completed tours found for this shift.</p>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default PackagingOperationsDashboard;
